<dac-navbar [doubleNav]="false"></dac-navbar>
<div class="view hm-black-light home-banner">
  <div class="full-bg-img">
    <div class="container">
      <div class="d-flex align-items-center d-flex justify-content-center" style="height: 600px">
        <div class="row mt-5">
          <div class="col-md-12 wow fadeIn mb-3">
              <div class="intro-info-content text-center">
                  <h1 class="h1-responsive mb-2 wow fadeInDown text-uppercase white-text" data-wow-delay="0.3s">{{title}}</h1>
                  <a class="btn btn-primary btn-lg wow fadeIn waves-light" [routerLink]="['/login']" mdbRippleRadius data-wow-delay="0.4s">Client Login</a>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Call to action-->
<div class="call-to-action mdb-color p-3">
    <div class="row text-center text-light">
      <div class="col">
        <h5>Interested in giving assessments to your clients?</h5>
      </div>
    </div>
    <div class="row">
      <div class="col text-center">
        <a [routerLink]="['/','register']" class="btn btn-secondary waves-light" mdbRippleRadius>Sign up as a therapist</a>
      </div>
    </div>
</div>




// WEBPACK FOOTER //
// ./src/app/home/home.component.html